import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from '../src/components/navbar';
import Footer from '../src/components/footer';
import Home from '../src/pages/home';
import About from './pages/about';
import Services from './pages/services';
import Contact from '../src/components/contact';
import 'animate.css';

const App = () => (
  <Router>
    <div className="flex flex-col min-h-screen">
      {/* Fixed Navbar */}
      <Navbar />

      {/* Content starts exactly below navbar (no extra visual gap) */}
      <main className="pt-20 flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      <Footer />
    </div>
  </Router>
);

export default App;
